/* eslint-disable @reatom/unit-naming-rule */
import { atom, reaction, sleep } from '@reatom/framework'

import { AsyncStateN, pipe } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { environmentAtom } from '@root/shared'
import { reatomResource } from '@root/shared/lib'

import { fetchNetworkDataRequestAction } from './network-data-requests'

export const networkDataByNetworkStateAtom = reatomResource(
  (ctx) => ctx.schedule(() => fetchNetworkDataRequestAction(ctx)),
  {
    name: 'networkDataByNetworkStateAtom',
    loadOnConnect: false,
    retry: {
      enabled: true,
    },
  },
)

export const networkDataAtom = networkDataByNetworkStateAtom.map(
  (ctx, it) => it[ctx.spy(selectedNetworkAtom)],
)

export const networkDataNativePriceAtom = networkDataAtom.map(
  (ctx, it) => it.nativePrice,
)

export const networkDataNativePriceStateAtom = atom((ctx) => {
  return pipe(
    ctx.spy(networkDataAtom),
    AsyncStateN.map((it) => it.nativePrice),
  )
}, 'networkDataNativePriceStateAtom')

export const priorityFeesStateAtom = networkDataAtom.map(
  (ctx, it) => it.priorityFees,
)

export const jitoAverageTipStateAtom = networkDataByNetworkStateAtom.map(
  (ctx, it) => it.solana.jitoAverageTips,
)

export const priorityFeesAtom = priorityFeesStateAtom.unwrap()

export const loadNetworkDataAction = networkDataByNetworkStateAtom.run

export const initializeNetworkDataPoolingReaction = reaction(async (ctx) => {
  const { nativePricesPollingInterval } = ctx.get(environmentAtom)
  loadNetworkDataAction(ctx)

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  while (true) {
    await ctx.schedule(() => sleep(nativePricesPollingInterval * 1000))
    await ctx.schedule(() => networkDataByNetworkStateAtom.refresh(ctx))
  }
}, 'initializeNetworkDataPoolingReaction')
